import  *  as moment from 'moment';

export const timeToDateTime = (time: string)=>{

    return `${moment().format('YYYY-MM-DD')} ${time}:00`

}